import src from "IMAGE";
export default { src, width: 5451, height: 1131, blurWidth: 0, blurHeight: 0};
